export const BP_CONTAINER_PAD_X = [16, 59, null, null, 107];
export const BP_CONTAINER_PAD_Y = [16, 40, null, null, 50];
export const BP_MAX_WIDTH = '1152px';

export const HEADER_X_SPACE = 10;

export const CARROUSEL_RADIUS = 8;